import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { noRecordFound } from './shift-break-details.constant';

@Component({
  standalone: false,
  selector: 'kt-shift-break-details',
  templateUrl: './shift-break-details.component.html',
  styleUrls: ['./shift-break-details.component.scss']
})
export class ShiftBreakDetailsComponent implements OnInit {
  noRecordFound = noRecordFound ;
  breaks: any = null;
  type: BREAK_TYPE_ENUM = null;
  buttonConfig = BUTTON_CONFIG;

  breakTypeEnum = BREAK_TYPE_ENUM;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {

  }

}
